import { openUrlInNewTab } from 'utils/urls';
import { Group, Shape } from '../../types';
import { drawTextUnderline } from './textUtils';

interface AddLinkOpts {
  /**
   * Shape to add link to.
   */
  shape: Shape;
  /** The url to link to in a new tab */
  url: string;
}

interface AddLinkStyleOpts {
  shape: AddLinkOpts['shape'];
  group: Group;
  isUnderlined?: boolean;
  maxWidth?: number;
}

/** Adds any associated link style.  EG: underline. */
const addLinkStyle = ({ group, isUnderlined = true, maxWidth, shape }: AddLinkStyleOpts) => {
  if (isUnderlined) {
    drawTextUnderline({ shape, group, maxWidth });
  }
};

export const addLink = ({ shape, url }: AddLinkOpts) =>
  shape.on('click', () => openUrlInNewTab(url));

/** Makes a text shape into a link */
export const addLinkToText = (props: AddLinkStyleOpts & AddLinkOpts) => {
  addLinkStyle(props);
  addLink(props);
};

/** Makes a text shape into a link that functions as a button */
export const addLinkButtonToText = (props: AddLinkStyleOpts) => {
  addLinkStyle(props);
};
